import {TemplateNode} from "#template/template-node/template-node"
import type {OnCompileContext, OnFilterActiveContext, TemplateNodeContext, VisitorNodeResult} from "#template/template-node/types"
import type {Evaluator} from "@cm/graph-v3"
import type {TemplateListNodeParameters} from "#template/template-list-node/types"
import {visitAll} from "#template/template-node/visit-helpers"

export abstract class TemplateListNode<out ItemType extends TemplateNode> extends TemplateNode<TemplateListNodeParameters<ItemType>> {
    override onFilterActive(
        _context: OnFilterActiveContext,
        evaluator: Evaluator<TemplateNodeContext>,
    ): VisitorNodeResult<TemplateListNodeParameters<ItemType>> {
        return visitAll(this.parameters, evaluator)
    }

    override onCompile(_context: OnCompileContext, evaluator: Evaluator<TemplateNodeContext>): VisitorNodeResult<TemplateListNodeParameters<ItemType>> {
        return visitAll(this.parameters, evaluator)
    }

    get entries(): readonly ItemType[] {
        return this.parameters.list
    }

    addEntry(entry: ItemType): void {
        this.replaceParameters({list: [...this.parameters.list, entry]})
    }

    removeEntry(entry: ItemType): void {
        const {list} = this.parameters
        const index = list.indexOf(entry)
        if (index === -1) return
        const newList = [...list]
        newList.splice(index, 1)
        this.replaceParameters({list: newList})
    }

    clear(): void {
        this.replaceParameters({list: []})
    }

    sortEntries(compareFn: (a: ItemType, b: ItemType) => number): void {
        this.replaceParameters({list: [...this.parameters.list].sort(compareFn)})
    }
}
